import React from "react";
import { Col, Space } from "antd";

import RentFAQList from "../../components/RentFAQList";

function QuestionsManagement() {
    return (
        <div className="container">
            <Space size={30} direction="vertical" style={{ width: "100%" }}>
                <h3 className="title">자주하는질문 관리</h3>
                <RentFAQList />
            </Space>
        </div>
    );
}

export default QuestionsManagement;
